import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent, ISpacing} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-alert-setting',
  templateUrl: './alert-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class AlertSettingComponent implements OnInit {
  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  constructor(private cs: CommonService) {

  }

  ngOnInit() {
    this.item.data = this.cs.setDefaultSetting(this.item.data);
  }

}
